var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blogroll_wrapper"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('img',{attrs:{"src":_vm.picAddr + item.friendlinkpicpath},on:{"click":function($event){return _vm.tolink(item)}}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }